import { Helmet } from 'react-helmet-async';
import EmentasListView from 'src/sections/ementas/view/ementas-list-view';

export default function EmentasListPage() {
  return (
    <>
      <Helmet>
        <title> Dashboard: Ementas</title>
      </Helmet>

      <EmentasListView />
    </>
  );
}
